import { render, staticRenderFns } from "./MADDFormStep4.vue?vue&type=template&id=f8afa776"
import script from "./MADDFormStep4.vue?vue&type=script&lang=js"
export * from "./MADDFormStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8afa776')) {
      api.createRecord('f8afa776', component.options)
    } else {
      api.reload('f8afa776', component.options)
    }
    module.hot.accept("./MADDFormStep4.vue?vue&type=template&id=f8afa776", function () {
      api.rerender('f8afa776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MADD/Form/MADDFormStep4.vue"
export default component.exports